((Modal, $) => {
  /**
    *
    *  Dependencies: Overlay.js
    *                components/_overlay.scss
    *                <div class="overlay" data-overlay></div> in theme.liquid
    *
    */

  const show = (modalName) => {
    window.Overlay.show();
    window.Scroll.lock();
    $(`[data-modal="${modalName}"]`).fadeIn(300);
    $('body').attr('data-active-modal', modalName);
  };

  const hide = () => {
    window.Overlay.hide();
    window.Scroll.unlock();
    $('[data-modal]').fadeOut(300);
    $('body').removeAttr('data-active-modal');
  };

  const arrows = () => {
    const modalLength = $('.modal.photo').length - 1;

    const checkKey = (e) => {
      const $currentModelImg = $('.modal.photo.open');

      e = e || window.event;
      if (e.keyCode == '37' || e.keyCode == '39') {
        $($currentModelImg).removeClass('open');
      }

      if (e.keyCode == '37') {
        if ($($currentModelImg).attr('data-index') == 0) {
          $(`.modal.photo[data-index="${modalLength}"]`).addClass('open');
        } else {
          $($currentModelImg).prev().addClass('open');
        }
      } else if (e.keyCode == '39') {
        if ($($currentModelImg).attr('data-index') == modalLength) {
          $('.modal.photo[data-index="0"]').addClass('open');
        } else {
          $($currentModelImg).next().addClass('open');
        }
      }
    };

    window.document.onkeydown = checkKey;
  };

  const bindUIActions = () => {
    $('[data-modal-show]').on('click', function (event) {
      event.preventDefault();
      show($(this).attr('data-modal-show'));
    });

    $('[data-modal-hide]').on('click', (event) => {
      event.preventDefault();
      hide();
    });

    arrows();
  };

  const init = () => {
    bindUIActions();
  };

  Modal.init = init;
  Modal.arrows = arrows;
  Modal.hide = hide;
  Modal.show = show;
})(window.Modal = window.Modal || {}, jQuery);
